<template>
 <div>
    <span id="add-btn-item">
      <button
        type="button"
        :disabled="!hasPermission('modify_order')"
        class="btn btn-success mt-5 mb-2"
        @click="newOrder"
        v-b-modal.new-item
      >
        + افزودن به سفارش
      </button>
    </span>

    <b-tooltip
      v-if="!hasPermission('modify_order')"
      target="add-btn-item"
      triggers="hover"
    >
      شما به این بخش دسترسی ندارید
    </b-tooltip>
  </div>
</template>

<script>
import {VBModal} from 'bootstrap-vue'
import {BTooltip} from 'bootstrap-vue'

export default {
  name: "OrderAddButton",
  components: {
    BTooltip
  },
  directives: {
    'b-modal': VBModal
  },
  methods: {
    newOrder() {
      this.$emit('new-order')
    }
  }
}
</script>

<style scoped>

</style>
